import { IScenarioType } from '@/types';
import { getUrl } from '@/utils/api';

function useScenarioTypes(filter?: string) {
  let url = `v1/scenario_types`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as IScenarioType[],
  };
}

export default useScenarioTypes;
